import { Dispatch } from "@reduxjs/toolkit";
import { AxiosError } from "axios";
import { api } from "../config/Api";
import { dataService } from "../config/DataService";
import { handleCatchResponse } from "../helper/helper";
import { ActivateDeactivateIndustryInterface, IndustryInterface, ResponseInterface } from "../helper/interface";
import { setLoading } from "../store/slice/BaseSlice";
import { addSuccessToast, editSuccessToast, successToast } from "../helper/toast";
import { FormikState } from "formik";
import { NavigateFunction } from "react-router-dom";

export const onAddIndustry = async (
    payload: IndustryInterface,
    dispatch: Dispatch,
    navigate: NavigateFunction,
    resetForm: (nextState?: Partial<FormikState<IndustryInterface>>) => void
) => {
    try {
        dispatch(setLoading(true));

        const response = await dataService.post(api.admin.addIndustry, {
            name: payload.name,
            positionIds: payload.positions?.map((ele) => ele.positionId) ?? [],
        });

        const res: Required<ResponseInterface<IndustryInterface>> = response.data;

        const toastLink = {
            primaryLinkTitle: "Add new",
            primaryLink: "/industry/add",
            secondaryLinkTitle: "Edit",
            secondaryLink: `/industry/edit/${res.data.industryId}`,
        };

        addSuccessToast(res.message, navigate, toastLink);
        navigate("/position");
    } catch (error) {
        handleCatchResponse(error as AxiosError);
    } finally {
        resetForm();
        dispatch(setLoading(false));
    }
};

export const onEditIndustry = async (data: IndustryInterface, navigate: NavigateFunction, dispatch: Dispatch) => {
    try {
        dispatch(setLoading(true));

        const payload = {
            name: data.name,
            positionIds: data.positions?.map((ele) => ele.positionId) ?? [],
        };

        const response = await dataService.post(`${api.admin.editIndustry}/${data.industryId}`, payload);

        const res: Required<ResponseInterface<IndustryInterface>> = response.data;

        const toastLink = {
            primaryLinkTitle: "Edit",
            primaryLink: `/industry/edit/${res.data.industryId ?? data.industryId}`,
        };

        editSuccessToast(res.message, navigate, toastLink);
        navigate("/position");
    } catch (error) {
        handleCatchResponse(error as AxiosError);
    } finally {
        dispatch(setLoading(false));
    }
};

export const onDeleteIndustry = async (industryId: number, dispatch: Dispatch, reload: () => void) => {
    try {
        dispatch(setLoading(true));

        const response = await dataService.delete(`${api.admin.deleteIndustry}/${industryId}`);

        const res = response.data;

        successToast(res.message);
    } catch (error) {
        handleCatchResponse(error as AxiosError);
    } finally {
        dispatch(setLoading(false));
        reload();
    }
};

export const onActivateDeactivateIndustry = async (data: ActivateDeactivateIndustryInterface, dispatch: Dispatch, reload: () => void) => {
    try {
        dispatch(setLoading(true));

        const payload = {
            isActive: data.isActive,
        };

        const response = await dataService.patch(`${api.admin.activateDeactivateIndustry}/${data.industryId}`, payload);

        const res = response.data;

        successToast(res.message);
    } catch (error) {
        handleCatchResponse(error as AxiosError);
    } finally {
        dispatch(setLoading(false));
        reload();
    }
};
